'use client';
import React, { useEffect, useState, useRef } from 'react';
import axios from '@/lib/axios';
import { toast } from 'react-toastify';

const CommunityPostForm = () => {
  const [search, setSearch] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const [attachedProduct, setAttachedProduct] = useState('');
  const [selectedProductId, setSelectedProductId] = useState<number | null>(
    null
  );
  const [postText, setPostText] = useState('');
  const [selectedImage, setSelectedImage] = useState<File | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const fileInputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      const fetchSuggestions = async () => {
        if (search.trim().length > 1) {
          try {
            const res = await axios.get(`/api/v2/gigalogy/items/search`, {
              params: { search },
            });
            setSuggestions(res.data?.data || []);
          } catch (error) {
            console.error('Axios search error:', error);
            setSuggestions([]);
          }
        } else {
          setSuggestions([]);
        }
      };

      fetchSuggestions();
    }, 400);

    return () => clearTimeout(delayDebounce);
  }, [search]);

  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      setSelectedImage(e.target.files[0]);
    }
  };

  const handlePost = async () => {
    if (!postText.trim()) {
      alert('Please enter a description');
      return;
    }

    setIsSubmitting(true);

    try {
      const formData = new FormData();

      // Add products array
      if (selectedProductId) {
        formData.append(
          'products',
          JSON.stringify([{ id: selectedProductId, name: attachedProduct }])
        );
      }

      // Add description
      formData.append('description', postText);

      // Add image if selected
      if (selectedImage) {
        formData.append('banner', selectedImage);
      }

      const response = await axios.post(
        'https://ecommerceapp.thetork.com/api/v2/community-post-create',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      // Reset form after successful post
      setPostText('');
      setAttachedProduct('');
      setSelectedProductId(null);
      setSelectedImage(null);
      setSearch('');
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }

      toast.success(response.data.message);
    } catch (error) {
      console.error('Error creating post:', error);
      toast.error('Failed to create post. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="community__form mb-4">
      <div className="community__form-body">
        <form className="community__create-post-form">
          <textarea
            className="community__textarea form-control mb-3"
            placeholder="What's on your mind?"
            rows={3}
            value={postText}
            onChange={(e) => setPostText(e.target.value)}
          />

          {/* Photo upload */}
          <div className="community__upload mb-3">
            <label className="form-label">Add Photo</label>
            <input
              type="file"
              accept="image/*"
              className="form-control"
              onChange={handleImageChange}
              ref={fileInputRef}
            />
          </div>

          {/* Select Product */}
          {/* <div className="search-module position-relative">
            <label className="form-label">Attach a Product</label>
            <div
              onSubmit={handleSearchButtonClick}
              className="search-bar d-flex"
            >
              <input
                type="text"
                className="search-bar__input flex-grow-1"
                placeholder="Search for product"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
              <div className="search-bar__search-buttons">
                <button
                  className="bg-transparent border-0 shadow-none"
                  onClick={handleSearchButtonClick}
                >
                  <HugeiconsIcon icon={Search01Icon} />
                </button>
              </div>
            </div>

            {suggestions?.length > 0 && (
              <div className="search">
                {suggestions.map((product: any) => (
                  <div
                    key={product.id}
                    className="mt-2 mx-3"
                    onClick={() => handleProductClick(product)}
                  >
                    <div className="search__media">
                      <NextImage
                        src={
                          product.small_pictures?.[0]?.url || '/placeholder.jpg'
                        }
                        alt={'Product image'}
                        width={50}
                        height={50}
                        className="search__image"
                      />
                      <div className="search__name">{product.name}</div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div> */}

          {/* selected product */}
          {/* <div className="search-module position-relative mt-3">
            <label className="form-label">Attached Product(Read Only)</label>
            <input
              type="text"
              className="search-bar__input flex-grow-1 border mb-3"
              placeholder="No product attached"
              value={attachedProduct || ''}
              readOnly
            />
          </div> */}

          {/* Post button */}
          <button
            type="button"
            className="community__submit trk-btn trk-btn--primary w-auto px-4"
            onClick={handlePost}
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Posting...' : 'Post'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default CommunityPostForm;

// 'use client';
// import React, { useEffect, useState } from 'react';
// import axios from '@/lib/axios';
// import { HugeiconsIcon } from '@hugeicons/react';
// import { Search01Icon } from '@hugeicons/core-free-icons';
// import NextImage from '../Image';

// const CommunityPostForm = () => {
//   const [search, setSearch] = useState('');
//   const [suggestions, setSuggestions] = useState([]);
//   const [attachedProduct, setAttachedProduct] = useState('');

//   useEffect(() => {
//     const delayDebounce = setTimeout(() => {
//       const fetchSuggestions = async () => {
//         if (search.trim().length > 1) {
//           try {
//             const res = await axios.get(`/api/v2/gigalogy/items/search`, {
//               params: { search },
//             });
//             setSuggestions(res.data?.data || []);
//           } catch (error) {
//             console.error('Axios search error:', error);
//             setSuggestions([]);
//           }
//         } else {
//           setSuggestions([]);
//         }
//       };

//       fetchSuggestions();
//     }, 400);

//     return () => clearTimeout(delayDebounce);
//   }, [search]);

//   const handleClearSuggestions = () => {
//     setSuggestions([]);
//   };

//   const handleSearchButtonClick = (e: any) => {
//     e.preventDefault();
//     handleClearSuggestions();
//     // router.push(`/shop?search=${search}`);
//   };

//   const emphasizeMatchWord = (text: string) => {
//     return text;
//   };

//   const handleProductClick = (productName: string) => {
//     setAttachedProduct(productName);
//     setSuggestions([]);
//   };

//   return (
//     <div className="community__form mb-4">
//       <div className="community__form-body">
//         <form className="community__create-post-form">
//           <textarea
//             className="community__textarea form-control mb-3"
//             placeholder="What's on your mind?"
//             rows={3}
//           />
//           {/* Photo upload */}
//           <div className="community__upload mb-3">
//             <label className="form-label">Add Photo</label>
//             <input type="file" accept="image/*" className="form-control" />
//           </div>

//           {/* Select Product */}
//           <div className="search-module position-relative">
//             <label className="form-label">Attach a Product</label>
//             <div
//               onSubmit={handleSearchButtonClick}
//               className="search-bar d-flex"
//             >
//               <input
//                 type="text"
//                 className="search-bar__input flex-grow-1"
//                 placeholder="Search for product"
//                 value={search}
//                 onChange={(e) => setSearch(e.target.value)}
//               />
//               <div className="search-bar__search-buttons">
//                 <button
//                   className="bg-transparent border-0 shadow-none"
//                   onClick={handleSearchButtonClick}
//                 >
//                   <HugeiconsIcon icon={Search01Icon} />
//                 </button>
//                 {/* todo: make it dynamic */}
//                 {/* <button className='bg-transparent border-0 shadow-none'>
//               <HugeiconsIcon icon={CenterFocusIcon} />
//             </button> */}
//               </div>
//             </div>

//             {suggestions?.length > 0 && (
//               <div className="search">
//                 {suggestions.map((product: any) => (
//                   <div
//                     key={product.id}
//                     className="mt-2 mx-3"
//                     onClick={() => handleProductClick(product.name)}
//                   >
//                     <div className="search__media">
//                       <NextImage
//                         src={
//                           product.small_pictures?.[0]?.url || '/placeholder.jpg'
//                         }
//                         alt={'Product image'}
//                         width={50}
//                         height={50}
//                         className="search__image"
//                       />
//                       <div
//                         className="search__name"
//                         dangerouslySetInnerHTML={{
//                           __html: emphasizeMatchWord(product.name),
//                         }}
//                       />
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             )}
//           </div>

//           {/* selected product */}
//           <div className="search-module position-relative mt-3">
//             <label className="form-label">Attachted Product(Read Only)</label>
//             <input
//               type="text"
//               className="search-bar__input flex-grow-1 border mb-3"
//               placeholder="Search for product"
//               value={attachedProduct || ''}
//               readOnly
//             />
//           </div>

//           {/* Post button */}
//           <button
//             type="button"
//             className="community__submit trk-btn trk-btn--primary"
//           >
//             Post
//           </button>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default CommunityPostForm;
